import { render, staticRenderFns } from "./programs-list.vue?vue&type=template&id=785077bf&"
import script from "./programs-list.vue?vue&type=script&lang=ts&"
export * from "./programs-list.vue?vue&type=script&lang=ts&"
import style0 from "./programs-list.vue?vue&type=style&index=0&id=785077bf&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports